export default "__VITE_ASSET__CYQF2Igu__"